import { Col } from "react-bootstrap"

import { MinusIcon } from "@heroicons/react/24/outline"

const MinusIconComp = ({ dmode }) => {
    return (
        <Col
            className="p-0"
            sm={1}
            style={{
                marginTop: 45,
                display: 'flex',
                justifyContent: 'start',
            }}
        >
            <MinusIcon
                style={{
                    height: 10,
                    width: 50,
                    color: dmode && 'white',
                }}
            />
        </Col>
    )
}

export default MinusIconComp